<template lang="pug">
    el-select(v-show="Companies && Companies.length > 1" v-model="selectValue", placeholder="Please enter a company", :loading="$apollo.loading")
        el-option(v-for="item in Companies", :key="item.id", :label="item.name", :value="item.id")
</template>

<script>
import UserCompaniesQuery from "@/graphql/queries/UserCompanies.js";

export default {
	name: "CompanySearch",
	props: {
		school: {
			type: Object,
			default: () => {}
		}
	},
	data: () => ({
		selection: ""
	}),
	computed: {
		selectValue: {
			get() {
				if (this.Companies) {
					this.$emit("companiesFromSelection", this.Companies);
					if (!this.selection) {
						this.$emit("input", this.Companies[0].id);
						return this.Companies[0].id;
					}
					return this.selection;
				}
				return null;
			},
			set(newValue) {
				this.selection = newValue;
				this.$emit("input", this.selection);
			}
		}
	},
	apollo: {
		Companies: {
			query: UserCompaniesQuery,
			update(r) {
				if (!this.school) return r.User.Companies;

				// find companies that are approved for the provided school
				const approvedCompanyIds = this.school.State.filter(s => s.state === "approved").map(s => s.Company.id);

				return r.User.Companies.filter(c => approvedCompanyIds.includes(c.id));
			}
		}
	}
};
</script>